'use strict';

import template from '../../templates/reports/Variance.ejs';
import tableTpl from '../../templates/reports/Variance-table.ejs';
import emptyTpl from '../../templates/reports/Variance-empty.ejs';
import moment from 'moment';

module.exports = Backbone.View.extend({
    render: function() {
        let lastPayroll = this.collection.at(0);
        let prevPayroll = this.collection.at(1);
        if (!lastPayroll || !prevPayroll) {
            this.$el.html(template({
                data: emptyTpl()
            }));
            return this;
        }

        let last = this.getItemsForPayroll(lastPayroll);
        let prev = this.getItemsForPayroll(prevPayroll);
        let diff = this.getDiff(prevPayroll, lastPayroll);
        this.$el.html(template({
            data: tableTpl({
                last: last,
                prev: prev,
                diff: diff
            })
        }));
        return this;
    },

    getDiff: function(prev, last) {
        return {
            base: (last.get('base') - prev.get('base')).formatWithoutRounding(),
            additions: (last.get('additions') - prev.get('additions'))
                .formatWithoutRounding(),
            deductions: (last.get('deductions') - prev.get('deductions'))
                .formatWithoutRounding(),
            grossPay: (last.get('grossPay') - prev.get('grossPay'))
                .formatWithoutRounding(),
            mtd: (last.get('mtd') - prev.get('mtd'))
                .formatWithoutRounding(),
            employeeEpf: (last.get('employeeEpf') - prev.get('employeeEpf'))
                .formatWithoutRounding(),
            employerEpf: (last.get('employerEpf') - prev.get('employerEpf'))
                .formatWithoutRounding(),
            employeeSocso: (last.get('employeeSocso') -
                            prev.get('employeeSocso')).formatWithoutRounding(),
            employerSocso: (last.get('employerSocso') -
                            prev.get('employerSocso')).formatWithoutRounding(),
            netPay: (last.get('netPay') - prev.get('netPay'))
                .formatWithoutRounding()
        };
    },

    getItemsForPayroll: function(payroll) {
        let items = {
            period: moment(payroll.get('periodDate')).format('MMMM YYYY'),
            base: payroll.get('base').formatWithoutRounding(),
            additions: payroll.get('additions').formatWithoutRounding(),
            deductions: payroll.get('deductions').formatWithoutRounding(),
            grossPay: payroll.get('grossPay').formatWithoutRounding(),
            mtd: payroll.get('mtd').formatWithoutRounding(),
            employeeEpf: payroll.get('employeeEpf').formatWithoutRounding(),
            employerEpf: payroll.get('employerEpf').formatWithoutRounding(),
            employeeSocso: payroll.get('employeeSocso').formatWithoutRounding(),
            employerSocso: payroll.get('employerSocso').formatWithoutRounding(),
            netPay: payroll.get('netPay').formatWithoutRounding()
        };
        return items;
    },

    remove: function() {
        this.undelegateEvents();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/reports/Variance.js